import { ReactElement } from 'react';
import { ModalWindow } from '~/components';
import { FullProg_v4 } from '~/providers/types';
import { ModalWrapper } from '../../SchedulesModals/DAM/components/ScheduleFormModal/styles';
import { DamScheduleList } from '../../SchedulesModals/DAM/components/ScheduleList';
import { DamVentilationForm } from '../../SchedulesModals/DAM/components/VentilationForm';

interface DamScheduleSummaryModalProps {
  prog: FullProg_v4;
  pendingProg?: boolean;
  onClose: () => void;
}

export function DamScheduleSummaryModal({
  prog,
  pendingProg,
  onClose,
}: Readonly<DamScheduleSummaryModalProps>): ReactElement {
  const ventilation = {
    start: String(prog.ventTime?.begin ?? 0),
    end: String(prog.ventTime?.end ?? 0),
  };

  return (
    <ModalWrapper>
      <ModalWindow
        borderTop
        onClickOutside={onClose}
        style={{ minWidth: 500, width: 'auto', maxHeight: '80vh' }}
      >
        <DamVentilationForm
          onChange={() => {}}
          defaultValues={ventilation}
          disabled
          onlyList
        />
        <DamScheduleList
          fixed
          lastProg={prog}
          onChangeProg={() => {}}
          onlyList
          pendingProg={pendingProg}
        />
      </ModalWindow>
    </ModalWrapper>
  );
}
